import { render, staticRenderFns } from "./BnplApplication.vue?vue&type=template&id=bafa706a&scoped=true&"
import script from "./BnplApplication.vue?vue&type=script&lang=js&"
export * from "./BnplApplication.vue?vue&type=script&lang=js&"
import style0 from "./BnplApplication.vue?vue&type=style&index=0&id=bafa706a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafa706a",
  null
  
)

export default component.exports